import { ModuleWithProviders, NgModule } from '@angular/core';
import { LOCALES_LIST, LocalesService } from './locales.service';
import { DropdownMenuModule } from '@backbase/ui-ang/dropdown-menu';
import { CommonModule } from '@angular/common';
import { BnSetLocaleWidgetCustomComponent } from './bn-set-locale-widget-custom.component';
import { IconModule } from '@backbase/ui-ang/icon';

@NgModule({
  declarations: [BnSetLocaleWidgetCustomComponent],
  imports: [
    DropdownMenuModule,
    CommonModule,
    IconModule
  ],
  exports: [BnSetLocaleWidgetCustomComponent],
  providers: [LocalesService],
})
export class BnSetLocaleWidgetCustomModule {
  static forRoot(config: {
    locales: Array<string>;
  }): ModuleWithProviders<BnSetLocaleWidgetCustomModule> {
    return {
      ngModule: BnSetLocaleWidgetCustomModule,
      providers: [
        {
          provide: LOCALES_LIST,
          useValue: config.locales,
        },
      ],
    };
  }
}
